import { PhasrApplyActionPanelWebComponent } from './component/PhasrApplyActionPanelWebComponent';
import { WEB_COMPONENT_PHASR_APPLY_ACTION_PANEL } from '../webcomponents.constants';

export { PhasrApplyActionPanelWebComponent };

window.customElements.define(WEB_COMPONENT_PHASR_APPLY_ACTION_PANEL, PhasrApplyActionPanelWebComponent);
